/**
 * Shared visual tokens for advice cards (Elite + Elite Prime, including Ideal).
 * Colors come from `--ep-advice-*` on `.elite-plans-root` so Elite stays peach
 * and Prime stays pink without CMS chrome overlays.
 */
export const ORANGE_ADVICE_CARD_THEME = {
  accentColor: 'var(--ep-accent)',
  backgroundGradient: 'var(--ep-advice-gradient)',
  dotsColor: 'var(--ep-advice-dots)',
  borderColor: 'var(--ep-advice-border)'
} as const

export const DEFAULT_ADVICE_CARD_GRADIENT = 'var(--ep-advice-gradient)'
export const DEFAULT_ADVICE_DOTS_COLOR = 'var(--ep-advice-dots)'
